module.exports = __webpack_public_path__ + "static/img/imcp.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/imcp.png
// module id = we+M
// module chunks = 0